// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { HardDriveDownload as RawHardDriveDownload } from "lucide-react";
export const HardDriveDownload = /* @__PURE__ */ createIcon(RawHardDriveDownload, "HardDriveDownload", 2);
